import { Mask } from '@models/utils/mask';


const defaultPhoneMaskFunction = (input: string): (RegExp | string)[] => {

  const value = input.replace(/[^\d]+/g, '');

  return value.length <= 10
         ? [ '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/ ]
         : [ '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/ ];
};

export const defaultPhoneMask: Mask = {
  guide:    false,
  showMask: false,
  mask:     defaultPhoneMaskFunction
};
